import { render, staticRenderFns } from "./CoreSearchField.vue?vue&type=template&id=76378b40&scoped=true&"
import script from "./CoreSearchField.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreSearchField.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CoreSearchField.vue?vue&type=style&index=0&id=76378b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76378b40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76378b40')) {
      api.createRecord('76378b40', component.options)
    } else {
      api.reload('76378b40', component.options)
    }
    module.hot.accept("./CoreSearchField.vue?vue&type=template&id=76378b40&scoped=true&", function () {
      api.rerender('76378b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreSearchField/CoreSearchField.vue"
export default component.exports